import React from 'react';
import PropTypes from 'prop-types';
import Search from './Search.jsx';
import Navigation from './Navigation.jsx';
import Image from '../../../../atoms/image/Image.jsx';

const Header = ({ data }) => {
  const { logo, languageSwitch, search, navigation } = data;

  return (
    <div className=" l-container l-container--has-margin">
      <div className="l-container__wrapper">
        <div className="l-container__grid">
          <div className="o-header__logo">
            <a href={logo.href} title={logo.label}>
              <Image {...logo.img} />
            </a>
          </div>
          <Navigation navigation={navigation} />
          <div className="o-header__meta">
            <div className="o-header__language-switch">
              <a
                className="a-link a-link--hover-petrol"
                href={languageSwitch.href}
                title={languageSwitch.label}
              >
                {languageSwitch.label}
              </a>
            </div>
            <Search search={search} />
          </div>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  data: PropTypes.shape().isRequired
};

export default Header;
